import { useMutation } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth.store';
import toast from 'react-hot-toast';
import { LoginPayload } from '@/schemas/login.schema';
import { useNavigate } from 'react-router-dom';
import { handleAnyError } from '@/lib/utils';

export const useLogin = () => {
    const navigate = useNavigate();

    return useMutation<void, Error, LoginPayload>({
        mutationFn: (payload: LoginPayload) => useAuthStore.getState().login(payload),
        onMutate: () => {
            useAuthStore.getState().setIsLoggingIn(true);
        },
        onSuccess: (dd) => {
            const { onboarding } = dd as unknown as { onboarding: { completed: boolean } };
 
            if (!onboarding?.completed) navigate('/complete-onboarding');
            else navigate('/dashboard');

            toast.success('Login successful');
        },
        onError: handleAnyError,
        onSettled: () => {
            useAuthStore.getState().setIsLoggingIn(false);
        },
    });
};

export const useLogout = () => {
    return useMutation<void, Error, void>({
        mutationFn: () => useAuthStore.getState().logoutServer(),
        onSuccess: () => {
            toast.success('Logged out successfully');
        },
        onError: (err: any) => {
            handleAnyError(err);
            // Ensure client-side cleanup regardless of server error
            useAuthStore.getState().logout();
        },
    });
};
